// zdm-scripts.js
console.log('zdm-scripts.js is loaded');

// Wrap first word in h3.section-title span with a span.title-first-word, but skip if first word contains a hyphen
// If text contains 'Experience Excellence', wrap those two words in the span instead
$(document).ready(function () {
    $('h3.section-title span').each(function () {
        var text = $(this).text();
        // Always override: if Experience Excellence is present, wrap it and skip other logic
        var expExRegex = /Experience Excellence/i;
        if (expExRegex.test(text)) {
            var replaced = text.replace(expExRegex, '<span class="title-first-word">$&</span>');
            $(this).html(replaced);
        } else {
            var firstWordMatch = text.match(/^\s*(\S+)/);
            if (firstWordMatch) {
                var firstWord = firstWordMatch[1];
                if (firstWord.indexOf('-') === -1) {
                    var rest = text.slice(firstWord.length);
                    $(this).html('<span class="title-first-word">' + firstWord + '</span>' + rest);
                }
                // If first word contains a hyphen, do nothing
            }
        }
    });
});

/* DEFINITIVE infinite scroll fix - patch theme's exact methods */
(function(){
    if (window.__ZDM_INFINITE_FIXED) return;
    window.__ZDM_INFINITE_FIXED = true;

    let isInfiniteScrolling = false;

    // Wait for theme objects to load
    const waitForTheme = () => {
        const $ = window.jQuery_T4NT || window.jQuery;
        if (!$) {
            setTimeout(waitForTheme, 100);
            return;
        }

        // 1. URL CLEANER - Remove page parameters completely
        const cleanPageURL = (url) => {
            if (!url || !url.includes('page=')) return url;
            
            // Just return the base pathname without any page parameters
            const cleanURL = window.location.pathname;
            console.log('🧹 Cleaned URL from:', url, 'to:', cleanURL);
            return cleanURL;
        };

        // 2. OVERRIDE history.pushState/replaceState to clean URLs
        const origPushState = history.pushState;
        const origReplaceState = history.replaceState;
        
        history.pushState = function(state, title, url) {
            const cleanURL = cleanPageURL(url);
            console.log('🚫 Blocked pushState, using replaceState with clean URL:', cleanURL);
            return history.replaceState(state, title, cleanURL);
        };

        history.replaceState = function(state, title, url) {
            const cleanURL = cleanPageURL(url);
            console.log('✅ Using clean replaceState:', cleanURL);
            return origReplaceState.call(history, state, title, cleanURL);
        };

        // 3. Override all scroll methods during infinite load
        const blockScroll = () => {
            isInfiniteScrolling = true;
            console.log('🔒 Scroll blocked for infinite load');
            
            setTimeout(() => {
                isInfiniteScrolling = false;
                console.log('🔓 Scroll unblocked');
            }, 2000);
        };

        // Intercept native scroll methods
        ['scrollTo', 'scroll', 'scrollBy'].forEach(method => {
            const orig = window[method];
            window[method] = function() {
                if (isInfiniteScrolling) {
                    console.log(`🚫 Blocked native ${method}`);
                    return;
                }
                return orig.apply(window, arguments);
            };
        });

        // 4. Intercept jQuery scroll animations
        const origAnimate = $.fn.animate;
        $.fn.animate = function(props, duration, easing, complete) {
            if (props && ('scrollTop' in props || 'scrollLeft' in props)) {
                if (isInfiniteScrolling) {
                    console.log('🚫 Blocked jQuery scroll animation');
                    return this;
                }
            }
            return origAnimate.apply(this, arguments);
        };

        // 5. Intercept AJAX calls that trigger infinite scroll
        const origAjax = $.ajax;
        $.ajax = function(options) {
            const settings = typeof options === 'string' ? {url: options} : options || {};
            
            if (settings.url && /[?&]page=\d+/.test(settings.url)) {
                console.log('🔄 Infinite scroll AJAX detected:', settings.url);
                blockScroll();
                
                // Wrap success callback
                const origSuccess = settings.success;
                settings.success = function() {
                    if (origSuccess) {
                        origSuccess.apply(this, arguments);
                    }
                    console.log('✅ Infinite scroll content loaded');
                    
                    // Clean URL after content loads
                    setTimeout(() => {
                        const currentURL = window.location.href;
                        const cleanURL = cleanPageURL(currentURL);
                        if (currentURL !== cleanURL) {
                            history.replaceState({}, '', cleanURL);
                        }
                    }, 100);
                };
            }
            
            return origAjax.call($, settings);
        };

        // 6. Monitor for DOM changes and block scroll
        const productContainers = ['.js_prs', '.js-prs', '.nt_ajax_prs', '.nt_products', '.products'];
        productContainers.forEach(selector => {
            const container = document.querySelector(selector);
            if (container) {
                const observer = new MutationObserver((mutations) => {
                    let hasNewProducts = false;
                    mutations.forEach(mutation => {
                        if (mutation.addedNodes.length > 0) {
                            // Check if added nodes contain product items
                            mutation.addedNodes.forEach(node => {
                                if (node.nodeType === 1 && (
                                    node.classList.contains('pr') ||
                                    node.classList.contains('product') ||
                                    node.querySelector('.pr, .product')
                                )) {
                                    hasNewProducts = true;
                                }
                            });
                        }
                    });
                    
                    if (hasNewProducts) {
                        console.log('📦 New products added to DOM');
                        blockScroll();
                        
                        // Clean URL after DOM updates
                        setTimeout(() => {
                            const currentURL = window.location.href;
                            const cleanURL = cleanPageURL(currentURL);
                            if (currentURL !== cleanURL) {
                                history.replaceState({}, '', cleanURL);
                            }
                        }, 200);
                    }
                });
                
                observer.observe(container, {
                    childList: true,
                    subtree: true
                });
                
                console.log('👀 Monitoring:', selector);
            }
        });

        // 7. Periodic URL cleaner (fallback)
        setInterval(() => {
            const currentURL = window.location.href;
            if (currentURL.includes('page=') && currentURL !== cleanPageURL(currentURL)) {
                const cleanURL = cleanPageURL(currentURL);
                console.log('🔄 Periodic URL cleanup:', cleanURL);
                history.replaceState({}, '', cleanURL);
            }
        }, 1000);

        console.log('🎉 Infinite scroll fix with URL cleaning initialized');
    };

    // Start monitoring
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForTheme);
    } else {
        waitForTheme();
    }
})();

// Equal height text overlays for blog slider
function equalizeOverlayHeights() {
    const sliders = document.querySelectorAll('.nt_se_blog-slider');
    
    sliders.forEach(slider => {
        const overlays = slider.querySelectorAll('.pa.tc.cg.w__100');
        if (overlays.length === 0) return;
        
        // Reset heights
        overlays.forEach(overlay => overlay.style.height = 'auto');
        
        // Get the tallest height
        let maxHeight = 0;
        overlays.forEach(overlay => {
            const height = overlay.scrollHeight;
            if (height > maxHeight) maxHeight = height;
        });
        
        // Apply max height to all
        if (maxHeight > 0) {
            overlays.forEach(overlay => {
                overlay.style.height = maxHeight + 'px';
            });
        }
    });
}

// Initialize equal height functionality
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(equalizeOverlayHeights, 100);
});

window.addEventListener('load', equalizeOverlayHeights);
window.addEventListener('resize', function() {
    setTimeout(equalizeOverlayHeights, 50);
});

